import { Box, Grid, LinearProgress } from '@mui/material';
import LangEnum from '../../../lang/LangEnum';
import { useOrderBookStyles } from '../styles/OrderBookStyles';
import OrderTargetListItem from './OrderTargetListItem';
import OrderTargetsLoadError from './components/OrderTargetsLoadError';
import useOrderTargetList from './useOrderTargetList';

interface OrderTargetListProps {
  orderId: string;
  showLoading: boolean;
}

const OrderTargetList = ({ orderId, showLoading }: OrderTargetListProps) => {
  const { classes } = useOrderBookStyles();
  const {
    targets,
    isFetching,
    isError,
    canOpenTarget,
    expandedTargetId,
    reload,
    toggleTarget,
    openTarget,
  } = useOrderTargetList(orderId);

  if (showLoading && isFetching && targets.length === 0) {
    return (
      <Box className={classes.horizontalPadding}>
        <LinearProgress />
      </Box>
    );
  }

  if (isError) {
    return <OrderTargetsLoadError message={LangEnum.TARGET_LIST_ERROR} onRetry={reload} />;
  }

  if (targets.length === 0) {
    return null;
  }

  return (
    <Grid container spacing={1} className={classes.horizontalPadding}>
      {targets.map((target, index) => (
        <Grid key={target.id} size={12}>
          <OrderTargetListItem
            target={target}
            testId={`order-target-${index}`}
            expansion={{
              isExpanded: expandedTargetId === target.id,
              toggle: () => toggleTarget(target.id),
            }}
            onOpenTarget={canOpenTarget ? () => openTarget(target.id) : undefined}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default OrderTargetList;
